module.exports = __webpack_public_path__ + "img/OAS_HandPaintedRunicSword_Steel_Pref.f5eaef6a.png";